var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNocoesArquivisticas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 0H13.75C6.1875 0 0 6.1875 0 13.75V61.875C0 69.4375 6.1875 75.625 13.75 75.625H110C117.562 75.625 123.75 69.4375 123.75 61.875V13.75C123.75 6.1875 117.562 0 110 0ZM110 41.25H88.4125C85.1812 41.25 82.6375 43.5187 81.7438 46.6125C79.2688 55.275 71.1562 61.875 61.875 61.875C52.5938 61.875 44.4812 55.275 42.0062 46.6125C41.1125 43.5187 38.5688 41.25 35.3375 41.25H13.75V20.625C13.75 16.8438 16.8438 13.75 20.625 13.75H103.125C106.906 13.75 110 16.8438 110 20.625V41.25ZM88.4812 89.375H116.875C120.656 89.375 123.75 92.4688 123.75 96.25V110C123.75 117.562 117.562 123.75 110 123.75H13.75C6.1875 123.75 0 117.562 0 110V96.25C0 92.4688 3.09375 89.375 6.875 89.375H35.2687C38.5 89.375 41.1125 91.7125 42.0062 94.875C44.4125 103.606 52.3875 110 61.875 110C71.3625 110 79.3375 103.606 81.7438 94.875C82.6375 91.7125 85.25 89.375 88.4812 89.375Z",
    fill: "#0F4C81"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNocoesArquivisticas);
export default __webpack_public_path__ + "static/media/NocoesArquivisticas.db1d724410f5f6b6ed69ff3f0950fe59.svg";
export { ForwardRef as ReactComponent };